import { type ReactNode } from 'react'
import { PrefetchedUserInfo } from 'app/components/entityInfo'
import { type TeamMemberData, type RoleData, teamMemberIsManager } from '@terros/common'
import { Group, Skeleton, Text } from '@mantine/core'

type Props = {
  visible?: boolean
  loading?: boolean
  members: TeamMemberData[] | undefined
  roles?: RoleData[]
}

export const ManagersDisplay = ({ visible, loading, members, roles = [] }: Props): ReactNode => {
  if (!visible) return null
  if (loading || !members) return <Skeleton h={20} w={76} />

  const onlyManagers = members.filter((m) => teamMemberIsManager(m, roles))
  const truncated = onlyManagers.length > 3 ? onlyManagers.slice(0, 3) : onlyManagers
  const truncatedCount = onlyManagers.length - truncated.length
  const isTruncated = truncatedCount > 0

  return (
    <Group gap={2} wrap='nowrap'>
      {truncated.map(({ user }) => (
        <PrefetchedUserInfo key={user.userId} avatarOnly linked={false} size='xs' user={user} />
      ))}
      {isTruncated && <Text size='xs'>{`+${truncatedCount} more`}</Text>}
    </Group>
  )
}
